/**
 * Shared Sentry Configuration
 * Used by client, server, and edge configs
 */

import pkg from './package.json';

export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const ENVIRONMENT = process.env.NEXT_PUBLIC_APP_ENV || 'development';

export const RELEASE = process.env.NEXT_PUBLIC_SENTRY_RELEASE || pkg.version;

// Common configuration shared across all Sentry configs
export const sharedConfig = {
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  release: RELEASE,
  enabled: !!SENTRY_DSN,
  sendDefaultPii: false,
  // Expected errors that shouldn't be reported
  ignoreErrors: ['Auth redirect'],
};
